module.exports = __webpack_public_path__ + "static/images/containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-100.8bf1fce6.png";


//////////////////
// WEBPACK FOOTER
// ./containers/Stronghold/components/Direction/components/Building/images/tankodrome-lvl1-100.png
// module id = 3327
// module chunks = 11